var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgGr = function SvgGr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 480,
    width: 640,
    viewBox: "0 0 640 480"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.67,
    d: "M0 0h120v90H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#a)",
    transform: "scale(5.33)",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0d5eaf",
    d: "M0 0h135v10H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 10h135v10H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0d5eaf",
    d: "M0 20h135v10H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 30h135v10H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0d5eaf",
    d: "M0 40h135v10H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 50h135v10H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0d5eaf",
    d: "M0 60h135v10H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 70h135v10H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0d5eaf",
    d: "M0 80h135v10H0zM0 0h50v50H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 0h10v50H20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 20h50v10H0z"
  })))));
};
export default __webpack_public_path__ + "assets/f796b4cbdc5de533e8ad16699f4e0c35.svg";
export { SvgGr as ReactComponent };


// WEBPACK FOOTER //
// ./assets/images/flags/4x3/gr.svg